function Tab(){
$('.js-tab').click(function(){
  $('.js-tab').removeClass('tab__block-active');
  $('.js-tab-res').removeClass('tab__container-active');
  var tab = $(this).data('tab');
  $(this).addClass('tab__block-active');
  $('.js-tab-res[data-tab="'+tab+'"]').addClass('tab__container-active');
  $(window).resize();
})
$('.js-selectcity__select').click(function(){
  $('.js-shipcity__result').css('display','block');
})
$('.js-trigger-accordion').click(function(e){
	e.preventDefault();
	var id = $(this).attr('href');
	$(id).find('.js-accordion-label').click();
});
$('.js-trigger-tab').click(function(e){
	e.preventDefault();
	var id = $(this).attr('href');
	$(id).click();
});
$(document).mouseup(function (e){
  var div = $(".js-shipcity__result");
  if ((!div.is(e.target) && $('.js-city__input').val() == '')) {
    $('.js-efects-click').removeClass('active');
  }
  if (!div.is(e.target)) {
    $('.js-shipcity__result').css('display','none');
  }
})
$('.js-selectcity__selectize').on('keyup',function(){
  if ($(this).val().length > 1) {
    $.ajax({
      method: "POST",
      url: "/cities/",
        data: { term: $(this).val()}
      }).then((data) => {
        $('.js-shipcity__result').html('');
        for (var i = 0; i < 50 && i<data.length; i++) {
          $('.js-shipcity__result').append('<div data-city_id="'+data[i].value+'" class="js-city-item selectmark__term--item">'+data[i].label+'</span></div>');
        }
        $('.js-shipcity__result').css('display','block');
        $('.js-shipcity__result .js-city-item').on('click',function(){
          $('.js-selectcity__selectize').val($(this).text());
          $('.js-shipment__types').addClass('m--loader');
          $('.js-shipment__types').html('');
          var inf = {
            city_id : $(this).data('city_id'),
          }
          $('.js-delivery-payment__block').addClass('m--loader');
          $('.js-delivery-payment__block').html('');
          var allInf = {
            city_id: $(this).data('city_id')
          };
          $.ajax({method:'POST',url:'/json/GetDeliveryData/',data: allInf}).then((data) => {
            $('.js-delivery-payment__block').html(data.content);
            $('.js-delivery-payment__block').removeClass('m--loader');
			$('.js-delivery-payment__block').find(".js-anchor-link").click(function () {
				let anim = $(this).data('href');
				let topanim = $(anim).offset().top;
				$("body,html").animate({scrollTop: topanim}, 800);
			});
            $('.js-accordion-label').click(function(){
              $(this).parent('.trigger').toggleClass('is--active');
              //if ($('.delivery-payment-karta').find('.js-__item').length != 0) {
			  if ($(this).parent('.trigger').find('.delivery-payment-karta .js-__item').length != 0) {
				if ($(this).parent('.trigger').find('.delivery-payment-karta ymaps').length == 0) {
                //if ($('.delivery-payment-karta').find('ymaps').length == 0) {

                  //$('.delivery-payment-karta').css('height','400px');
          		  $(this).parent('.trigger').find('.delivery-payment-karta').css('height','400px');
				  var id = $(this).parent('.trigger').find('.delivery-payment-karta').attr('id');
                  ymaps.ready(init(id));
                  function init(id) {

                    var i = 0;
                    var myMap = new ymaps.Map(id, {
                      center: [55.159843, 61.426125],
                      zoom: 17
                    })
                    var clusterer = new ymaps.Clusterer({
                        preset: 'islands#invertedBlueClusterIcons',
                        groupByCoordinates: false,
                        clusterDisableClickZoom: false,
                        clusterHideIconOnBalloonOpen: false,
                        geoObjectHideIconOnBalloonOpen: false
                    })
                    var myCollection = new ymaps.GeoObjectCollection(null, {
                        preset: 'islands#blueIcon'});
                    $('#' + id + ' .js-__item').each(function(){
                      let placemark = new ymaps.Placemark([$(this).data('coordy'), $(this).data('coordx')], {
                          balloonContentHeader: $(this).data('name'),
                          balloonContentBody: "<div class='js-map-cont' data-address='"+$(this).data('address')+"' data-time='"+$(this).data('time')+"' data-phone='"+$(this).data('phone')+"' data-name='"+$(this).data('name')+"' data-code='"+$(this).data('code')+"' data-postalcode='"+$(this).data('postalcode')+"'>Адрес: <span class='important16'>"+$(this).data('address')+"</span><br>Телефон: <span class='important16'>"+$(this).data('phone')+"</span><br>Время работы:<span class='important16'>"+$(this).data('time')+"</span>",
                        });
                        clusterer.add(placemark);
                    })
                    myMap.geoObjects.add(clusterer);
                    myMap.setBounds(myMap.geoObjects.getBounds(), {checkZoomRange: true});
                  }
                }
              }
            })
          })
        })
      })
    }
  })
}

export {
  Tab
};